import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import Activity from 'app/apiService/activity/activityApiService';

// ----------- Type Definitions -----------
interface ActivityContextType {
  loading: boolean;
  error: string | null;
  activities: any[];
  meta: any;
  getActivities: (params?: any) => Promise<void>;
}

// ----------- Context Create -----------
const ActivityContext = createContext<ActivityContextType | undefined>(undefined);

// ----------- Provider Component -----------
export const ActivityProvider: React.FC<{ children: ReactNode; dealerId?: string }> = ({ children, dealerId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [activities, setActivities] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});

  const getActivities = async (params?: any) => {
    setLoading(true);
    setError(null);
    try {
      const response = await Activity.getActivities({
        activityType: 'ACTIVE_OUTREACH',
        ...(dealerId ? { dealer_id: dealerId } : {}),
        skip: 0,
        limit: 10,
        ...params,
      });
      setActivities(response.body?.data || []);
      setMeta(response.body?.meta || {});
    } catch (err: any) {
      setError(err.message || 'Failed to fetch activities');
    } finally {
      setLoading(false);
    }
  };

  // Disabled auto-fetch so activities load only when explicitly requested.
  // useEffect(() => {
  //   if (dealerId) getActivities();
  // }, [dealerId]);

  const value = {
    loading,
    error,
    activities,
    meta,
    getActivities,
  };

  return (
    <ActivityContext.Provider value={value}>
      {children}
    </ActivityContext.Provider>
  );
};

// ----------- Custom Hook -----------
export const useActivity = (): ActivityContextType => {
  const context = useContext(ActivityContext);
  if (context === undefined) {
    throw new Error('useActivity must be used within an ActivityProvider');
  }
  return context;
}; 